import { find, includes, toInteger } from 'lodash';
import { findSeatEl, findCustomSeatEl } from 'lib/seats/seatFinders';

export default function(
  subLineItem,
  seatData,
  prices,
  performances,
  lockedPriceTypes
) {
  let seat = find(seatData, function(x) {
    return x.seat_no === toInteger(subLineItem.seat_no);
  });

  let price = find(prices, function(x) {
    return (
      x.price_type === subLineItem.price_type &&
      ((x.zones && x.zones.indexOf(subLineItem.zone_no) !== -1) ||
        x.zone_no === subLineItem.zone_no)
    );
  });

  let performance = find(performances, function(x) {
    return toInteger(x.perf_no) === toInteger(subLineItem.perf_no);
  });

  if (seat && price) {
    let result = {
      cartItem: subLineItem,
      seatEl: findSeatEl(seat),
      customSeatEl: findCustomSeatEl(seat),
      seatData: seat,
      priceData: price,
      performance: performance
    };

    if (lockedPriceTypes) {
      result.isLocked = includes(
        lockedPriceTypes,
        toInteger(subLineItem.price_type)
      );
    } else {
      result.isLocked = false;
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/repopulateSubLineItem.js